import { hooksStore } from "../../../stores/hooks.store";
import { userStore } from "../../../stores/user.store";
import { tempStore } from "../../../stores/temp.store";

import { getMap, pointTo } from "../../../helpers/map";
import { object_filter } from "../../../helpers/functions";

import set from "set-value";
import get from "get-value";
import length from "@turf/length";
import { get as get_store } from "svelte/store";

export function merajVzdialenost(merania) {
  const map = getMap();
  const innerIndex = merania.length ? merania[merania.length - 1].index + 1 : 1;

  let store = get_store(tempStore);
  set(store, "meranieAktivne", true);
  tempStore.set(store);

  merania[merania.length] = {
    index: innerIndex,
    id: `meranie_${innerIndex}`,
    nazov: `Meranie ${innerIndex}`,
    vzdialenost: 0,
    type: "meranie",
    napoveda: `Meranie začnite kliknutím na počiatočný bod na mape`,
    geojson: {
      type: "FeatureCollection",
      features: [],
    },
  };
  // merania = [...merania, meranie];
  const meranieIndex = merania.findIndex((m) => m.index === innerIndex);
  merania[meranieIndex].geojson.features = [];
  const linestring = {
    type: "Feature",
    geometry: {
      type: "LineString",
      coordinates: [],
    },
  };

  map.addSource(merania[meranieIndex].id, {
    type: "geojson",
    data: merania[meranieIndex].geojson,
    generateId: true,
  });

  // Add styles to the map
  map.addLayer({
    id: "measure-points-" + merania[meranieIndex].id,
    type: "circle",
    source: merania[meranieIndex].id,
    paint: {
      "circle-radius": 5,
      "circle-color": [
        "case",
        ["boolean", ["feature-state", "hover"], false], // Set this to false
        "#64bdbb",
        "#000",
      ],
    },
    filter: ["in", "$type", "Point"],
  });
  map.addLayer({
    id: "measure-lines-" + merania[meranieIndex].id,
    type: "line",
    source: merania[meranieIndex].id,
    layout: {
      "line-cap": "round",
      "line-join": "round",
    },
    paint: {
      "line-color": [
        "case",
        ["boolean", ["feature-state", "hover"], false], // Set this to false
        "#64bdbb",
        "#000",
      ],
      "line-width": 2.5,
    },
    filter: ["in", "$type", "LineString"],
  });

  map.on("click", mapOnClick);

  map.on("mousemove", mapOnMove);

  function mapOnMove(e) {
    const features = map.queryRenderedFeatures(e.point, {
      layers: ["measure-points-" + merania[meranieIndex].id],
    });
    // Change the cursor to a pointer when hovering over a point on the map.
    // Otherwise cursor is a crosshair.
    map.getCanvas().style.cursor = features.length ? "pointer" : "crosshair";
  }
  function mapOnClick(e) {
    const features = map.queryRenderedFeatures(e.point, {
      layers: ["measure-points-" + merania[meranieIndex].id],
    });

    // Remove the linestring from the group
    // so we can redraw it based on the points collection.
    if (merania[meranieIndex].geojson.features.length > 1) {
      merania[meranieIndex].geojson.features.pop();
    }

    if (merania[meranieIndex].geojson.features.length > 0) {
      merania[
        meranieIndex
      ].napoveda = `Meranie ukončíte kliknutím na prvy alebo posledný bod.`;
    }

    // ak som klikol na prvy bod, tak ho pridam, aby sa dokreslila ciara
    if (
      features.length &&
      merania[meranieIndex].geojson.features[0].properties.id ===
        features[0].properties.id
    ) {
      const point = {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates:
            merania[meranieIndex].geojson.features[0].geometry.coordinates,
        },
        properties: {
          id: String(new Date().getTime()),
        },
      };
      merania[meranieIndex].geojson.features.push(point);
    }
    if (features.length) {
      // If a feature was clicked, remove it from the map.
      const id = features[0].properties.id;

      // ak je kliknuty posledny alebo prvy bod, ukoncuje sa meranie
      if (
        merania[meranieIndex].geojson.features[
          merania[meranieIndex].geojson.features.length - 1
        ].properties.id === id ||
        merania[meranieIndex].geojson.features[0].properties.id === id
      ) {
        map.off("click", mapOnClick);
        map.off("mousemove", mapOnMove);
        map.getCanvas().style.cursor = "pointer";
        merania[meranieIndex].napoveda = "";

        // povolenie dvojkliku musi prebehnut o malicko neskor, inak by sa hned dvojklik spravil
        setTimeout(() => {
          set(store, "meranieAktivne", false);
          tempStore.set(store);
        }, 10);
      } else {
        merania[meranieIndex].geojson.features = merania[
          meranieIndex
        ].geojson.features.filter((point) => point.properties.id !== id);
      }
    } else {
      const point = {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [e.lngLat.lng, e.lngLat.lat],
        },
        properties: {
          id: String(new Date().getTime()),
        },
      };

      merania[meranieIndex].geojson.features.push(point);
    }

    if (merania[meranieIndex].geojson.features.length > 1) {
      linestring.geometry.coordinates = merania[
        meranieIndex
      ].geojson.features.map((point) => point.geometry.coordinates);

      merania[meranieIndex].geojson.features.push(linestring);

      // Populate the distanceContainer with total distance
      const value = document.createElement("pre");
      const distance = length(linestring);
      if (distance > 1) {
        merania[meranieIndex].vzdialenost = `${distance.toLocaleString()} km`;
      } else {
        merania[meranieIndex].vzdialenost = `${(distance * 1000).toFixed(
          0
        )} m (${distance.toLocaleString()} km)`;
      }
    }

    map
      .getSource(merania[meranieIndex].id)
      .setData(merania[meranieIndex].geojson);

    hooksStore.doAction(
      "ulozVrstvyDoStavu",
      merania[meranieIndex],
      merania[meranieIndex].id,
      merania[meranieIndex].geojson,
      "meranie"
    );

    // ak je druhy krat kliknute na prvy bod (napr dvojklik), tak take nulove meranie rovno zmaze
    if (
      merania[meranieIndex].geojson.features.length > 2 &&
      merania[meranieIndex].geojson.features[0].geometry.coordinates[0] ===
        merania[meranieIndex].geojson.features[1].geometry.coordinates[0] &&
      merania[meranieIndex].geojson.features[0].geometry.coordinates[1] ===
        merania[meranieIndex].geojson.features[1].geometry.coordinates[1]
    ) {
      odstranVrstvuZMapy(merania, merania[meranieIndex].index);
    }
  }
}

function generateId(onlyNo = false) {
  const list = document.querySelectorAll("#merania .meranie");
  const no = list.length + 1;

  if (onlyNo) {
    return no;
  }
  return `meranie_${no}`;
}

/**
 * Odstranim vrstvu z mapy aj z pamate a tym padom aj z navigacneho okienka
 * @param source_id
 */
export function odstranVrstvuZMapy(merania, ind) {
  const map = getMap();
  const index = merania.findIndex((m) => m.index === ind);
  // prechadzam vsetky layery, nie sources, lebo najprv treba vymazat layer
  map.getStyle().layers.forEach(function (layer) {
    // ak ma layer spravny source, tak ho vymazem
    if (merania[index].id === layer.source) {
      map.removeLayer(layer.id);
    }
  });

  // ak existuje source ktory mam vymazat
  if (map.getSource(merania[index].id)) {
    map.removeSource(merania[index].id);

    // zmazem informaciu aj z pamate stavu uzivatela
    const user = userStore.getUser();
    let stav = get(user, "options.mapa.stav", false) || {};

    if (get(stav[merania[index].id]) !== undefined) {
      delete stav[merania[index].id];
    }
    set(user, "options.mapa.stav", stav);
    userStore.updateUser(user);
  }
  merania.splice(index, 1);
  merania = [...merania];
}

export function doPointTo(merania, ind) {
  const map = getMap();
  const index = merania.findIndex((m) => m.index === ind);
  let highlightedFeatures = map.querySourceFeatures(merania[index].id);
  pointTo(map.getSource(merania[index].id)._data);
}

export function zvyrazni(merania, ind, highlight = true) {
  const map = getMap();
  const index = merania.findIndex((m) => m.index === ind);
  let highlightedFeatures = map.querySourceFeatures(merania[index].id);

  highlightedFeatures.forEach(function (f) {
    // For each feature, update its 'highlight' state
    map.setFeatureState(
      {
        source: merania[index].id,
        id: f.id,
      },
      {
        hover: highlight,
      }
    );
  });
}

export function zobrazUlozeneMeraniaNaMape(merania) {
  const user = userStore.getUser();
  const map = getMap();

  let stav = get(user, "options.mapa.stav", false) || {};
  if (stav !== undefined) {
    const filtrovane = object_filter(
      stav,
      (vrstva) => vrstva.typ_vrstvy !== "meranie"
    );
    for (const property in filtrovane) {
      merania.push(filtrovane[property].data);

      map.addSource(filtrovane[property].data.id, {
        type: "geojson",
        data: filtrovane[property].sourceData,
        generateId: true,
      });

      // Add styles to the map
      map.addLayer({
        id: "measure-points-" + filtrovane[property].data.id,
        type: "circle",
        source: filtrovane[property].data.id,
        paint: {
          "circle-radius": 5,
          "circle-color": [
            "case",
            ["boolean", ["feature-state", "hover"], false], // Set this to false
            "#64bdbb",
            "#000",
          ],
        },
        filter: ["in", "$type", "Point"],
      });
      map.addLayer({
        id: "measure-lines-" + filtrovane[property].data.id,
        type: "line",
        source: filtrovane[property].data.id,
        layout: {
          "line-cap": "round",
          "line-join": "round",
        },
        paint: {
          "line-color": [
            "case",
            ["boolean", ["feature-state", "hover"], false], // Set this to false
            "#64bdbb",
            "#000",
          ],
          "line-width": 2.5,
        },
        filter: ["in", "$type", "LineString"],
      });
    }
    merania = [...merania];

    return merania;
  }
}
